import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import { Router } from '@angular/router';
import { DattaConfig } from 'src/app/config/app-config';

 
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  @Output() onNavCollapsedMob = new EventEmitter();
  @Input() public IsSkyaccessAppNavBar : boolean = false;
   
  public dattaConfig: any; 
  public navCollapsedMob;
  public headerStyle: string;
  public menuClass: boolean; 
  public collapseStyle: string; 
  public isApp: boolean;


  constructor(private _router : Router) {
    this.dattaConfig = DattaConfig.config;
    this.navCollapsedMob = false;
    this.headerStyle = '';
    this.menuClass = false;
    this.collapseStyle = 'none';
  }

  ngOnInit() {
    this.isApp = this.IsSkyaccessAppNavBar;
  }
 
  toggleMobOption() {
    this.menuClass = !this.menuClass;
    this.headerStyle = (this.menuClass) ? 'none' : '';
    this.collapseStyle = (this.menuClass) ? 'block' : 'none';
  }


  NavigateToChat() : void {
    this._router.navigate(['hotel/chat']);
  }

}
